/**
 * Full fallback labels resources from src/locales.
 * Used when generated/labels-resources.json is missing or empty (e.g. production build edge case).
 * Mirrors the structure built by gatsby-node createPages fallback.
 */

import enUsCommon from '../../locales/en-us/common.json';
import enUsSeo from '../../locales/en-us/seo.json';
import enUsPricing from '../../locales/en-us/pricing.json';

import enGbCommon from '../../locales/en-gb/common.json';
import enGbSeo from '../../locales/en-gb/seo.json';
import enGbPricing from '../../locales/en-gb/pricing.json';

import enAuCommon from '../../locales/en-au/common.json';
import enAuSeo from '../../locales/en-au/seo.json';
import enAuPricing from '../../locales/en-au/pricing.json';

import frFrCommon from '../../locales/fr-fr/common.json';
import frFrSeo from '../../locales/fr-fr/seo.json';
import frFrPricing from '../../locales/fr-fr/pricing.json';

import deDeCommon from '../../locales/de-de/common.json';
import deDeSeo from '../../locales/de-de/seo.json';
import deDePricing from '../../locales/de-de/pricing.json';

import esEsCommon from '../../locales/es-es/common.json';
import esEsSeo from '../../locales/es-es/seo.json';
import esEsPricing from '../../locales/es-es/pricing.json';

import itItCommon from '../../locales/it-it/common.json';
import itItSeo from '../../locales/it-it/seo.json';
import itItPricing from '../../locales/it-it/pricing.json';

import ptPtCommon from '../../locales/pt-pt/common.json';
import ptPtSeo from '../../locales/pt-pt/seo.json';
import ptPtPricing from '../../locales/pt-pt/pricing.json';

import heIlCommon from '../../locales/he-il/common.json';
import heIlSeo from '../../locales/he-il/seo.json';
import heIlPricing from '../../locales/he-il/pricing.json';

import roRoCommon from '../../locales/ro-ro/common.json';
import roRoSeo from '../../locales/ro-ro/seo.json';
import roRoPricing from '../../locales/ro-ro/pricing.json';

import csCzCommon from '../../locales/cs-cz/common.json';
import csCzSeo from '../../locales/cs-cz/seo.json';
import csCzPricing from '../../locales/cs-cz/pricing.json';

import fiFiCommon from '../../locales/fi-fi/common.json';
import fiFiSeo from '../../locales/fi-fi/seo.json';
import fiFiPricing from '../../locales/fi-fi/pricing.json';

import nlNlCommon from '../../locales/nl-nl/common.json';
import nlNlSeo from '../../locales/nl-nl/seo.json';
import nlNlPricing from '../../locales/nl-nl/pricing.json';

import plPlCommon from '../../locales/pl-pl/common.json';
import plPlSeo from '../../locales/pl-pl/seo.json';
import plPlPricing from '../../locales/pl-pl/pricing.json';

import arXaCommon from '../../locales/ar-xa/common.json';
import arXaSeo from '../../locales/ar-xa/seo.json';
import arXaPricing from '../../locales/ar-xa/pricing.json';

type LabelsResource = Record<string, Record<string, unknown>>;

export const fallbackResources: LabelsResource = {
  'en-us': { common: enUsCommon as Record<string, unknown>, seo: enUsSeo as Record<string, unknown>, pricing: enUsPricing as Record<string, unknown> },
  'en-gb': { common: enGbCommon as Record<string, unknown>, seo: enGbSeo as Record<string, unknown>, pricing: enGbPricing as Record<string, unknown> },
  'en-au': { common: enAuCommon as Record<string, unknown>, seo: enAuSeo as Record<string, unknown>, pricing: enAuPricing as Record<string, unknown> },
  'fr-fr': { common: frFrCommon as Record<string, unknown>, seo: frFrSeo as Record<string, unknown>, pricing: frFrPricing as Record<string, unknown> },
  'de-de': { common: deDeCommon as Record<string, unknown>, seo: deDeSeo as Record<string, unknown>, pricing: deDePricing as Record<string, unknown> },
  'es-es': { common: esEsCommon as Record<string, unknown>, seo: esEsSeo as Record<string, unknown>, pricing: esEsPricing as Record<string, unknown> },
  'it-it': { common: itItCommon as Record<string, unknown>, seo: itItSeo as Record<string, unknown>, pricing: itItPricing as Record<string, unknown> },
  'pt-pt': { common: ptPtCommon as Record<string, unknown>, seo: ptPtSeo as Record<string, unknown>, pricing: ptPtPricing as Record<string, unknown> },
  'he-il': { common: heIlCommon as Record<string, unknown>, seo: heIlSeo as Record<string, unknown>, pricing: heIlPricing as Record<string, unknown> },
  'ro-ro': { common: roRoCommon as Record<string, unknown>, seo: roRoSeo as Record<string, unknown>, pricing: roRoPricing as Record<string, unknown> },
  'cs-cz': { common: csCzCommon as Record<string, unknown>, seo: csCzSeo as Record<string, unknown>, pricing: csCzPricing as Record<string, unknown> },
  'fi-fi': { common: fiFiCommon as Record<string, unknown>, seo: fiFiSeo as Record<string, unknown>, pricing: fiFiPricing as Record<string, unknown> },
  'nl-nl': { common: nlNlCommon as Record<string, unknown>, seo: nlNlSeo as Record<string, unknown>, pricing: nlNlPricing as Record<string, unknown> },
  'pl-pl': { common: plPlCommon as Record<string, unknown>, seo: plPlSeo as Record<string, unknown>, pricing: plPlPricing as Record<string, unknown> },
  'ar-xa': { common: arXaCommon as Record<string, unknown>, seo: arXaSeo as Record<string, unknown>, pricing: arXaPricing as Record<string, unknown> },
};
